/**
 * @author      hugo@zumper.com (Hugo Pineda)
 * @copyright   Copyright (c) 2023, Zumper
 */

import { LINKPACK_LINK_CLICKED, event } from '@zcode-ui/web-zumper-integrations'
import type { HandleLinkClickArgs } from '@zcode-ui/web-zumper-ui'
import { EVENT_NAMES, PAGE_NAMES, PROP_NAMES, track } from '@zcode/mixpanel'
import { HOMEPAGE as HOMEPAGE_SECTIONS } from '@zcode/mixpanel'
import { AnalyticsC, trackGAEvent } from '@zcode/nr-utils'
import type { Dispatch, State } from '@zcode/state-type'
import { connect } from 'react-redux'
import { selectAddressLinks, selectBuildingLinks } from '../../../modules/homepage/selectors/index'
import { HomepageLinks, type HomepageLinksProps } from './HomepageLinks'

const mapStateToProps = (state: State) => {
  return {
    addressLinks: selectAddressLinks(state),
    buildingLinks: selectBuildingLinks(state),
  } satisfies Partial<HomepageLinksProps>
}

export const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    trackLinkClick: ({ eventName, link, section }: HandleLinkClickArgs) => {
      trackGAEvent(AnalyticsC.HOMEPAGE, 'Homepage Link', eventName, link)
      dispatch(event({ name: LINKPACK_LINK_CLICKED, props: { link, section } }))
      track({
        event: EVENT_NAMES.CLICK,
        payload: {
          [PROP_NAMES.PAGE_NAME]: PAGE_NAMES.HOMEPAGE,
          [PROP_NAMES.SECTION]: HOMEPAGE_SECTIONS.LINKPACKS,
          [PROP_NAMES.LINK_CLICKED]: link,
        },
      })
    },
  } satisfies Partial<HomepageLinksProps>
}

export const HomepageLinksContainer = connect(mapStateToProps, mapDispatchToProps)(HomepageLinks)
